import React, { createContext, useContext, useRef } from 'react';
import { toast } from 'sonner';

export const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
  const lastToastRef = useRef(null);

  const showToast = (message, type = 'success') => {
    // Dedupe: if same toast message was just shown, ignore
    if (lastToastRef.current === message) {
      return;
    }

    lastToastRef.current = message;

    // Clear the deduplication after a short delay
    setTimeout(() => {
      if (lastToastRef.current === message) {
        lastToastRef.current = null;
      }
    }, 1000);

    // Map types to Sonner's toast methods
    if (type === 'error') {
      toast.error(message, {
        duration: 2500, // 2.5s for errors
      });
    } else if (type === 'info') {
      toast.info(message, {
        duration: 3000, // 3s for info
      });
    } else {
      toast.success(message, {
        duration: 5000, // 5s for success
      });
    }
  };

  const hideToast = () => {
    toast.dismiss();
  };

  return (
    <ToasterContext.Provider value={{ showToast, hideToast }}>
      {children}
    </ToasterContext.Provider>
  );
};

export const useToaster = () => {
  const context = useContext(ToasterContext);
  if (!context) {
    throw new Error('useToaster must be used within a ToasterProvider');
  }
  return context;
};